import React from 'react'
import { Table } from "reactstrap";

type PropsTablaDetalles<Tentidad> = {
    registrosTabla: Tentidad[]
}



function TablaDetalles<TEntidad extends object>(props: PropsTablaDetalles<TEntidad>) {


    function SepararNombresCampos(nombre:string){

        if(nombre.includes("_")){
            return nombre.replace("_"," ");
        }
        return nombre;

        
    }

    const nombresPropiedades: string[] = Object.keys(props.registrosTabla[0]);
    return (
        <>

            <Table bordered className="tableHistorialSolicitudesVacaciones" responsive>

                <thead className="cabecerasDetallehistorialSolic">
                    <tr className="" >

                        {nombresPropiedades.map((nombres, indice) => {
                            return (
                                <th key={"thtabladetalles" + indice}>
                                    {SepararNombresCampos(nombres)}
                                </th>
                            )
                        })}

                    </tr>
                </thead>

                <tbody>
                    {props.registrosTabla.map((filas, indice) => {
                        return (
                            <tr className="rowHistorialSolicitudVacaciones">
                                {Object.keys(filas).map((nombres, indice) => {
                                    return (
                                        <td className="">
                                            <div className="">
                                                {filas[nombres]}
                                            </div>

                                        </td>
                                    )
                                })}
                            </tr>
                        )
                    })}

                </tbody>
            </Table>

        </>
    )
}

export default TablaDetalles